var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divider",class:_vm.classes},[(_vm.hasSlot)?_c('span',{staticClass:"inner"},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }